<template>
    <div class="h-100 d-flex flex-column">
        <div class="sidebar-top">

        </div>
        <div class="sidebar-bot btn-box">
        </div>
    </div>
</template>
<script>
import store from './../../mixins/store.mixin';

export default {
    name: 'SidebarLeftSettings',
    props: {},
    components: {
    },
    mixins: [store],
    data() {
        return {};
    },
    mounted: function () {},
    created: function () {},
    methods: {},
    computed: {},
};
</script>
<style lang="scss" scoped>
.sidebar-item {
  padding: 20px 20px;
  border-bottom: 1px solid #CBCBCB;
  width: 100%;
  background: white;
  color: black;
}

.btn-box {
  min-height: 105px;
  height: 105px;
}
.gap-10 {
    gap: 10px;
}
</style>
